// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"67555010","453":"a9adf1bb","455":"58544ec8","977":"87e457b1"}[chunkId] + ".chunk.js";
};